import React from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import styles from './PaymentSuccess.module.css';

const DiningPaymentSuccess = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const order = location.state?.order || null;
    const orderId = order?.id || searchParams.get('order_id');

    return (
        <div className={styles.psPage}>
            <div className={styles.psCard}>

                <div className={styles.psHeader}>
                    <div className={styles.psHeaderLeft}>
                        <span className={styles.psEyebrow}>Order Confirmation</span>
                        <h1 className={styles.psBrand}>Aurelia Dining</h1>
                    </div>
                    {orderId && (
                        <div className={styles.psHeaderRight}>
                            <span className={styles.psInvoiceLabel}>Order</span>
                            <span className={styles.psInvoiceNum}>#ORD-{orderId}</span>
                        </div>
                    )}
                </div>

                <div className={styles.psStatusStrip}>
                    <span className={styles.psStatusDot} />
                    <span className={styles.psStatusText}>Payment Successful</span>
                    <span className={styles.psStatusSub}>Your order has been sent to the kitchen</span>
                </div>

                <div className={styles.psBody}>
                    {order ? (
                        <>
                            <h2 className={styles.psSectionTitle}>Order Details</h2>
                            <div className={styles.psDetailGrid}>
                                <div className={styles.psDetailCell}>
                                    <span className={styles.psDetailLabel}>Customer</span>
                                    <span className={styles.psDetailValue}>{order.customer_name}</span>
                                </div>
                                <div className={styles.psDetailCell}>
                                    <span className={styles.psDetailLabel}>Type</span>
                                    <span className={styles.psDetailValue}>
                                        {order.order_type === 'delivery' ? `Room ${order.room_number}` : order.location}
                                    </span>
                                </div>
                            </div>

                            {order.items?.length > 0 && (
                                <div className={styles.psDetailGrid}>
                                    <div className={`${styles.psDetailCell} ${styles.psDetailCellWide}`}>
                                        <span className={styles.psDetailLabel}>Items</span>
                                        {order.items.map(item => (
                                            <div key={item.id} className={styles.psDetailValue}>
                                                {item.quantity}x {item.item_name} — ₦{Number(item.subtotal).toLocaleString()}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <p className={styles.psTitle}>Your payment was received successfully.</p>
                    )}
                </div>

                {order && (
                    <div className={styles.psTotalBand}>
                        <span className={styles.psTotalLabel}>Total Amount Paid</span>
                        <span className={styles.psTotalValue}>₦{Number(order.total_amount).toLocaleString()}</span>
                    </div>
                )}

                <div className={styles.psActions}>
                    <button onClick={() => navigate('/dining')} className={styles.psBtnOutline}>
                        Back to Menu
                    </button>
                    <button onClick={() => navigate('/')} className={styles.psBtnPrimary}>
                        Go to Home
                    </button>
                </div>

                <div className={styles.psFooter}>
                    <p className={styles.psFooterHeadline}>Thank you for dining with Aurelia.</p>
                    <p className={styles.psFooterSub}>Need help with your order? Email <a href="mailto:sales@aurelia-apartments.com">sales@aurelia-apartments.com</a></p>
                </div>

            </div>
        </div>
    );
};

export default DiningPaymentSuccess;
